// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xZuoskPAQrNJ81 {
  margin-top: var(--ds-space-100, 8px);
  border-top: 1px solid var(--ds-border, #091e4224);
}
.xZuoskPAQrNJ81 fieldset {
  display: flex;
  flex-direction: column;
  margin-top: var(--ds-space-100, 8px);
  border: none;
}
.xZuoskPAQrNJ81 .NQllANamWE_HCR {
  display: flex;
  align-items: center;
  margin-bottom: var(--ds-space-150, 12px);
  gap: var(--ds-space-100, 8px);
}
.xZuoskPAQrNJ81 .NQllANamWE_HCR .gOPL0_1YSe_lcY {
  align-items: baseline;
  padding: var(--ds-space-050, 4px) var(--ds-space-150, 12px) var(--ds-space-050, 4px) var(--ds-space-050, 4px);
  background-color: var(--ds-background-neutral, #091e420f);
  color: var(--ds-text, #172b4d);
}
.xZuoskPAQrNJ81 .NQllANamWE_HCR .gOPL0_1YSe_lcY input[type='checkbox'] {
  appearance: none;
}
.xZuoskPAQrNJ81 .NQllANamWE_HCR .gOPL0_1YSe_lcY:hover,
.xZuoskPAQrNJ81 .NQllANamWE_HCR .gOPL0_1YSe_lcY:focus {
  cursor: pointer;
}
.xZuoskPAQrNJ81 .NQllANamWE_HCR .gOPL0_1YSe_lcY.Ru1GgSbOoeWArI {
  background-color: var(--ds-background-neutral-hovered, #091e4224);
  color: var(--ds-text, #172b4d);
}
.xZuoskPAQrNJ81 .JUc7PqhDDiZwn3 {
  max-width: max-content;
  margin-top: var(--ds-space-100, 8px);
}
`, ""]);
// Exports
export var feedbackDetailContainer = `xZuoskPAQrNJ81`;
export var reasonsContainer = `NQllANamWE_HCR`;
export var reason = `gOPL0_1YSe_lcY`;
export var selected = `Ru1GgSbOoeWArI`;
export var submitButton = `JUc7PqhDDiZwn3`;
export default ___CSS_LOADER_EXPORT___;
